import { render, staticRenderFns } from "./RiverTimeline.vue?vue&type=template&id=4d31cc92&scoped=true&"
import script from "./RiverTimeline.vue?vue&type=script&lang=js&"
export * from "./RiverTimeline.vue?vue&type=script&lang=js&"
import style0 from "./RiverTimeline.vue?vue&type=style&index=0&id=4d31cc92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d31cc92",
  null
  
)

export default component.exports